import { useEffect } from 'react';
import { AppState } from '@constants';
import { setFirebaseLanguageFromCountry } from '@utils/firebase';

/**
 * Hook to update Firebase Auth language code when the user's country changes.
 * This ensures Firebase emails (verification, password reset) are sent in the correct language.
 *
 * @param state - The app state containing firebaseAuth and country
 */
function useFirebaseLocaleUpdate(state: AppState): void {
  useEffect(() => {
    if (state.firebaseAuth && state.country) {
      setFirebaseLanguageFromCountry(state.firebaseAuth, state.country);
    }
  }, [state.firebaseAuth, state.country]);
}

export default useFirebaseLocaleUpdate;
